module.exports = __webpack_public_path__ + "static/media/module4.9105a408.jpg";